import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const mode = process.env.REACT_APP_SENTRY_MODE;
const release = process.env.REACT_APP_SENTRY_RELEASE;

Sentry.init({
  dsn,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // tracePropagationTargets: [],
  environment: mode, // "development" | "production"
  release: release,
});
